import { render } from "./MainYTe.vue?vue&type=template&id=dde17030"
import script from "./MainYTe.vue?vue&type=script&lang=js"
export * from "./MainYTe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__